module.exports = __webpack_public_path__ + "media/images/business/i-branding-b48918cd0dba906c348735d16a742d5f.svg";